import React, { Component } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Col, Layout, Row } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { Link, Navigate, Outlet } from 'react-router-dom';
import { RoutesConfig } from '../../config';
import { IRootStoreProps, WithoutStore, withStore } from '../../stores';
import { observer } from 'mobx-react';

const routesConfig = new RoutesConfig();

class Auth extends Component<IRootStoreProps> {
  render() {
    const { user } = this.props.store;
    const path = window.location.pathname;

    if (user.isAuth && !path.includes(routesConfig.confirmEmail)) {
      return <Navigate to={routesConfig.gameKnb} />;
    }

    return (
      <Layout style={{ height: '100vh' }}>
        <Row style={{ height: '100%' }}>
          <Col
            xs={0}
            sm={12}
            style={{
              position: 'relative',
              height: '100%',
            }}
          >
            <img
              src="/images/auth-image.png"
              alt="Example"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                position: 'absolute',
                top: 0,
                left: 0,
              }}
            />
          </Col>
          <Col
            xs={24}
            sm={12}
            style={{
              position: 'relative',
              height: '100%',
            }}
          >
            <Link to={routesConfig.home}>
              <Button
                type="text"
                style={{ position: 'absolute', top: 20, right: 20 }}
                icon={<CloseOutlined style={{ fontSize: 30 }} />}
              />
            </Link>
            <Content
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
              }}
            >
              <Col xs={22} sm={20} md={20} lg={18}>
                <Outlet />
              </Col>
            </Content>
          </Col>
        </Row>
      </Layout>
    );
  }
}

export const AuthLayout: WithoutStore = withStore(observer(Auth));
